import React from 'react';
import styles from './SignUpContainerStyles.scss';

const SignUpContainer = ({ children, width = 600, style }) => (
  <div className={styles.container} style={{ width, ...style }}>
    {children}
  </div>
);

export default SignUpContainer;
